import type { MessageKey } from "./en";
import { APP_NAME } from "../config/brand";

/** German UI copy — must cover every key in en.ts (pinned by a test). */
export const de: Record<MessageKey, string> = {
  "app.name": APP_NAME,
  "landing.login": "Anmelden",
  "landing.getStarted": "Loslegen",
  "landing.eyebrow": "telc- & Goethe-Prüfungsvorbereitung",
  "landing.h1": "Bestehen Sie Ihre Deutschprüfung mit Sicherheit.",
  "landing.sub": "Vollständige Prüfungsübungen, ein strukturierter Kurs und KI-Feedback für jedes Niveau von A1 bis C1 — telc und Goethe, alles an einem Ort.",
  "landing.ctaPrimary": "Jetzt lernen",
  "landing.ctaSecondary": "Was drin ist",
  "landing.boards": "Übungsmaterial nach dem Format der telc- und Goethe-Prüfungen.",
  "landing.statItems": "Prüfungsaufgaben",
  "landing.statLessons": "geführte Lektionen",
  "landing.statWords": "Wörter Wortschatz",
  "landing.statLevels": "jedes Niveau",
  "landing.featuresTitle": "Alles, was Sie bis zur Prüfung brauchen.",
  "landing.featuresSub": "Kein Videokurs und keine Karteikarten-App — der ganze Weg vom ersten Wort bis zum Prüfungstag.",
  "landing.f1t": "Prüfungsübungen",
  "landing.f1b": "2.736 Aufgaben zu Lesen, Hören, Schreiben und Sprechen — genau im telc- und Goethe-Format, mit sofortiger Bewertung.",
  "landing.f2t": "Geführter Kurs",
  "landing.f2b": "240 Lektionen auf einem klaren Weg — Wortschatz, eine Grammatikregel, eine Tabelle, ein Dialog, Übungen und je eine kurze Schreib- und Sprechaufgabe.",
  "landing.f3t": "Nachschlagen & Wiederholen",
  "landing.f3b": "50 Grammatiktabellen und 7.200 Wörter, jederzeit griffbereit — mit verteilter Wiederholung, damit die Wörter sitzen.",
  "landing.f4t": "KI-Schreib- & Sprechcoach",
  "landing.f4b": "Schreiben oder sprechen Sie und erhalten Sie in Sekunden Feedback — bewertet nach den echten Prüfungskriterien, mit Korrekturen.",
  "landing.f5t": "Modellprüfungen",
  "landing.f5b": "Vollständige Prüfungssimulationen, die jeden Teil an der 60%-Grenze bewerten — so wissen Sie vor dem Ernstfall, wo Sie stehen.",
  "landing.f6t": "Ihr Können-Check",
  "landing.f6b": "Sechs Fertigkeitswerte aus allem, was Sie tun, plus die eine nächste Aufgabe — kein Rätselraten mehr, was zu üben ist.",
  "landing.pricingTitle": "Kaufen Sie genau das, was Sie brauchen.",
  "landing.pricingSub": "Ein einzelnes Niveau, ein komplettes Niveau oder ein Paket für eine ganze Schule. Zahlen Sie für eine Fertigkeit oder den ganzen Weg.",
  "landing.popular": "Am beliebtesten",
  "landing.planLearnerT": "Ein Lernender, ein Niveau",
  "landing.planLearnerB": "Kaufen Sie nur den Kurs oder nur die Prüfungsübungen für Ihr Niveau. Sie sind Konto und Lernender zugleich.",
  "landing.planCompleteT": "Komplettes Niveau",
  "landing.planCompleteB": "Kurs und Prüfungsübungen für ein Niveau zusammen — günstiger als beide Hälften einzeln, inklusive KI-Feedback.",
  "landing.planSchoolT": "Für Schulen",
  "landing.planSchoolB": "Mehrplatz-Pakete mit allen Niveaus. Legen Sie Konten für Ihre Lernenden an und verwalten Sie alles zentral.",
  "landing.finalTitle": "Bereit anzufangen?",
  "landing.finalSub": "Erstellen Sie ein Konto und beginnen Sie auf Ihrem Niveau. Ihre Schule oder unser Team schaltet den Rest frei.",
  "landing.footer": "Deutsch-Prüfungsvorbereitung für telc und Goethe.",
  "landing.howTitle": "Vom ersten Wort bis zum Prüfungstag.",
  "landing.step1t": "Niveau bestimmen",
  "landing.step1b": "Ein kurzer Einstufungstest verortet Sie auf der GER-Skala und zeigt Ihre sechs Fertigkeitswerte — kein Rätselraten, wo Sie anfangen.",
  "landing.step2t": "Lernen und üben",
  "landing.step2b": "Arbeiten Sie den geführten Kurs und echte Prüfungsaufgaben Seite an Seite durch — mit verteilter Wiederholung, damit jedes Wort sitzt.",
  "landing.step3t": "Modellprüfung ablegen",
  "landing.step3b": "Eine vollständige Prüfung unter Zeit bewertet jeden Teil an der 60%-Grenze — so hält der Prüfungstag keine Überraschungen bereit.",
  "landing.ladderNote": "jedes Niveau abgedeckt",
  "nav.dashboard": "Übersicht",
  "nav.store": "Shop",
  "store.title": "Shop",
  "store.subtitle": "Fügen Sie Niveaus und KI-Guthaben zu Ihrem Konto hinzu.",
  "store.levels": "Niveaus",
  "store.owned": "Im Besitz",
  "store.creditMonthly": "{amount} pro Monat inklusive",
  "credits.low": "Ihre Schule hat {percent}% des KI-Guthabens dieses Monats verbraucht.",
  "credits.outAdmin": "Die im Abo enthaltene KI ist für diesen Monat aufgebraucht. Am 1. gibt es wieder neue - vorher hilft ein Aufladen.",
  "credits.outLearner": "Die im Abo enthaltene KI Ihrer Schule ist diesen Monat aufgebraucht. Bis zum 1. pausiert das KI-Feedback. Bitten Sie Ihre Lehrkraft aufzuladen.",
  "credits.topUp": "Aufladen",
  "credits.tasterGone": "Sie haben Ihr kostenloses KI-Gespräch genutzt. Mit einem Abo können Sie weiter mit dem KI-Partner üben.",
  "credits.tasterGoneLearner": "Das kostenlose KI-Gespräch wurde genutzt. Fragen Sie Ihre Lehrkraft nach einem Abo.",
  "credits.seePlans": "Preise ansehen",
  "store.creditBalance": "KI-Guthaben",
  "store.creditsTitle": "KI-Guthaben",
  "store.creditsBody": "Ihr KI-Guthaben bezahlt Schreibfeedback, den Sprechpartner und Antwort-Erklärungen. Jede Antwort kostet so viel wie das gewählte Modell - je günstiger der Partner, desto weiter reicht das Guthaben. Ihr Paket enthält ein monatliches Kontingent; hier laden Sie bei Bedarf auf.",
  "store.kind.learn": "Kurs",
  "store.kind.practice": "Übungen",
  "store.kind.complete": "Komplett",
  "store.total": "Gesamt",
  "store.itemCount": "{count} im Warenkorb",
  "store.placeOrder": "Bestellung aufgeben",
  "store.orderPlaced": "Bestellung aufgegeben — per Überweisung bezahlen",
  "store.amountToPay": "Zu zahlender Betrag",
  "store.reference": "Verwendungszweck",
  "store.quoteReference": "Geben Sie diesen Verwendungszweck bei der Überweisung an, damit wir Ihre Zahlung zuordnen können.",
  "store.transferTo": "Überweisen an",
  "store.accountName": "Kontoinhaber",
  "store.accountNumber": "Kontonummer",
  "store.bankName": "Bank",
  "store.ifsc": "IFSC",
  "store.orderItems": "Ihre Bestellung",
  "store.contact": "Fragen? Kontakt",
  "nav.orders": "Bestellungen",
  "nav.classes": "Klassen",
  "tour.body.classes": "Legen Sie fest, wer was lernt. Weisen Sie einer Klasse Niveaus zu — alle Mitglieder erhalten sie — oder geben Sie einzelnen Lernenden etwas zusätzlich.",
  "classes.title": "Klassen",
  "classes.subtitle": "Ihre Schule kauft ein Niveau einmal; hier wählen Sie, welche Lernenden es bekommen. Weisen Sie es einer Klasse zu, dann erhält es jedes Mitglied — Einzelne können Zusätzliches bekommen.",
  "classes.newClass": "Neue Klasse",
  "classes.name": "Klassenname",
  "classes.namePlaceholder": "z. B. Klasse 1, Abendkurs B1",
  "classes.create": "Klasse anlegen",
  "classes.empty": "Noch keine Klassen. Legen Sie eine an, um Niveaus zuzuweisen.",
  "classes.delete": "Löschen",
  "classes.modules": "Niveaus für diese Klasse",
  "classes.members": "Lernende in dieser Klasse ({count})",
  "classes.noPupils": "Noch keine Lernenden — legen Sie sie zuerst unter Team an.",
  "classes.noModules": "Ihre Schule hat noch keine Niveaus. Kaufen Sie zuerst eines im Shop.",
  "classes.saved": "Gespeichert.",
  "classes.individual": "Einzelne Lernende",
  "classes.individualBody": "Für Ausnahmen — wenn jemand etwas braucht, das seine Klasse nicht hat. Dies kommt zu den Klassen-Zuweisungen hinzu.",
  "classes.pupil": "Lernende/r",
  "classes.choosePupil": "Lernende/n wählen…",
  "classes.extraModules": "Zusätzliche Niveaus für diese Person",
  "classes.effective": "Aktuell zugänglich",
  "classes.nothingYet": "noch nichts",
  "classes.grantAll": "Alles zuweisen, was die Schule besitzt",
  "classes.autoGrant": "Neue Lernende",
  "classes.autoGrantBody": "Neue Lernende erhalten beim Annehmen der Einladung automatisch alle Niveaus, die die Schule besitzt. Schalten Sie dies aus, wenn Sie jede Person einzeln zuweisen möchten.",
  "admin.orders.heading": "Überweisungsbestellungen",
  "admin.orders.headingSub": "Zahlungen abgleichen und die Bankdaten verwalten, an die Lernende überweisen.",
  "admin.orders.title": "Offene Bestellungen",
  "admin.orders.subtitle": "Markieren Sie eine Bestellung als bezahlt, sobald die Überweisung eingeht — das schaltet die Pakete frei.",
  "admin.orders.none": "Keine offenen Bestellungen.",
  "admin.orders.ref": "Verwendungszweck",
  "admin.orders.tenant": "Konto",
  "admin.orders.items": "Artikel",
  "admin.orders.amount": "Betrag",
  "admin.orders.markPaid": "Als bezahlt markieren",
  "admin.orders.cancel": "Stornieren",
  "admin.orders.paidDone": "Bestellung freigeschaltet.",
  "admin.orders.cancelled": "Bestellung storniert.",
  "admin.pay.title": "Zahlungsdaten",
  "admin.pay.subtitle": "Das Bankkonto und der Kontakt, die Lernenden in der Überweisungsanleitung angezeigt werden.",
  "admin.pay.contactEmail": "Kontakt-E-Mail",
  "admin.pay.note": "Hinweis für Käufer",
  "admin.pay.save": "Speichern",
  "admin.pay.saved": "Zahlungsdaten gespeichert.",
  "tour.help": "Kurze Einführung",
  "locked.title": "{level} {kind} gehört noch nicht zu Ihrem Paket",
  "locked.body": "Es ist nichts schiefgegangen — dieses Niveau ist für Ihr Konto einfach noch nicht freigeschaltet. Fügen Sie {level} {kind} im Shop hinzu, dann steht es sofort bereit.",
  "locked.cta": "Im Shop freischalten",
  "learn.objectives": "Am Ende dieser Lektion können Sie",
  "learn.lineGloss": "Satz für Satz",
  "learn.wordBank": "Wortschatz",
  "learn.pronunciation": "Aussprache",
  "learn.minimalPairs": "Hören Sie den Unterschied",
  "learn.culture": "Landeskunde",
  "learn.translation": "Ins Deutsche übersetzen",
  "learn.translationHint": "Schreiben Sie jeden Satz auf Deutsch und zeigen Sie dann die Musterlösung.",
  "learn.showAnswers": "Lösungen zeigen",
  "learn.lessonTest": "Lernkontrolle",
  "learn.points": "Punkte",
  "learn.submitTest": "Abgeben",
  "learn.yourScore": "Ihr Ergebnis",
  "learn.recall": "Können Sie sich erinnern?",
  "learn.reveal": "Antwort zeigen",
  "learn.lockedBuy": "Noch nicht in Ihrem Paket — dieses Niveau im Shop freischalten",
  "learn.lockedAsk": "Noch nicht in Ihrem Paket — bitten Sie Ihre Schulverwaltung, dieses Niveau freizuschalten.",
  "locked.askAdmin": "Bitten Sie Ihre Schulverwaltung, {level} {kind} für Ihr Konto freizuschalten.",
  "locked.askAdminGeneric": "Bitten Sie Ihre Schulverwaltung, das für Sie freizuschalten.",
  "store.adminOnly": "Ihre Schulverwaltung bestellt die Niveaus für Ihr Konto. Bitten Sie sie um das, was Sie brauchen.",
  "locked.genericTitle": "Für Ihr Konto nicht freigeschaltet",
  "locked.genericBody": "Ihr Paket enthält das noch nicht. Im Shop können Sie es hinzufügen.",
  "tour.step": "{n} von {total}",
  "tour.next": "Weiter",
  "tour.back": "Zurück",
  "tour.skip": "Überspringen",
  "tour.done": "Alles klar",
  "tour.welcome.title": "Willkommen — so funktioniert es",
  "tour.welcome.body": "Eine kurze Tour: wo alles ist und was Sie zuerst tun. Dauert etwa 30 Sekunden — mit dem ?-Knopf können Sie sie jederzeit wiederholen.",
  "tour.askDoubt.title": "In Ihrer eigenen Sprache fragen",
  "tour.askDoubt.body": "Sie üben auf Deutsch, muessen aber nie darin feststecken. Stellen Sie Ihre Frage bei jeder Lektion oder Uebung auf Hindi, Punjabi oder Englisch - die Antwort kommt in derselben Sprache zurueck.",
  "tour.final.title": "Womit Sie anfangen",
  "tour.final.body": "Starten Sie auf Ihrer Übersicht — dort sehen Sie unsere Empfehlung und Ihren Können-Check. Holen Sie sich ein Niveau im Shop und beginnen Sie dann unter Lernen mit Lektion 1.",
  "tour.body.dashboard": "Ihre Startseite. Hier sehen Sie unsere Empfehlung, Ihre sechs Fertigkeitswerte und die nächste sinnvolle Aufgabe.",
  "tour.body.learn": "Ihr Kurs, Lektion für Lektion der Reihe nach. Jede Lektion hat Wortschatz, eine Grammatikregel, einen Dialog, Übungen sowie eine kurze Schreib- und Sprechaufgabe.",
  "tour.body.reference": "Schlagen Sie jederzeit alles nach — Grammatiktabellen und Wortlisten für jedes Niveau, dazu Wiederholung, bis die Wörter sitzen.",
  "tour.body.notebook": "Ihr privater Notizblock. Halten Sie beim Lernen eine Regel, ein Wort oder eine Frage fest — es bleibt bei Ihrem Konto und nur Sie sehen es.",
  "tour.body.history": "Jede Frage an die KI und jedes Gespräch wird hier gespeichert — eine gute Erklaerung geht nie verloren.",
  "tour.body.store": "Hier holen Sie sich ein Niveau. Wählen Sie den Kurs, die Prüfungsübungen oder beides und geben Sie Ihre Bestellung auf. Bis dahin bleiben Lektionen und Übungen gesperrt.",
  "tour.body.practice": "Echte Prüfungsaufgaben im telc- und Goethe-Format — Lesen, Hören, Schreiben und Sprechen, sofort bewertet. Auch vollständige Modellprüfungen finden Sie hier.",
  "tour.body.speak": "Sprechen Sie mit dem KI-Partner und erhalten Sie Feedback zu Ihrem Sprechen — bewertet wie in der Prüfung.",
  "tour.body.team": "Fügen Sie Lehrkräfte und Lernende zu Ihrer Schule hinzu und verwalten Sie deren Konten.",
  "tour.body.access": "Legen Sie fest, wer was sehen und tun darf — Rechte pro Person vergeben oder entziehen.",
  "tour.body.billing": "Ihr Tarif, Rechnungen und Zahlungen.",
  "tour.body.tenants": "Alle Schulen auf der Plattform — anlegen, ansehen und Module verwalten.",
  "tour.body.orders": "Überweisungsbestellungen, die noch abzugleichen sind. Als bezahlt markieren schaltet die Pakete frei.",
  "tour.body.revenue": "Was die Plattform über alle Schulen hinweg einnimmt.",
  "tour.body.ai": "Wählen Sie, welcher KI-Anbieter die Anfragen der Plattform beantwortet.",
  "tour.body.aiUsage": "Sehen Sie, wie viele KI-Tokens Ihre Lernenden pro Monat verbrauchen.",
  "usage.name": "Name",
  "store.error": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  "store.recommended": "Empfohlen",
  "admin.credits.title": "KI-Guthaben",
  "admin.credits.thisMonth": "{granted} gewährt, {spent} verbraucht diesen Monat",
  "admin.credits.amount": "Betrag (Rupien)",
  "admin.credits.reason": "Grund",
  "admin.credits.reasonHint": "z. B. Kulanz, Erstattung, Korrektur",
  "admin.credits.apply": "Anpassung anwenden",
  "admin.credits.done": "Guthaben aktualisiert.",
  "admin.credits.monthly": "Monatliches Guthaben",
  "admin.credits.perMonth": "pro Monat",
  "admin.credits.monthlyHint": "Wird zu Monatsbeginn automatisch dem Guthaben gutgeschrieben. 0 nutzt das Kontingent des Tarifs. Änderungen gelten ab der nächsten Gutschrift.",
  "admin.credits.monthlySave": "Guthaben speichern",
  "admin.credits.monthlySaved": "Monatliches Guthaben gespeichert.",
  "admin.credits.failed": "Guthaben konnte nicht angepasst werden.",
  "nav.reference": "Nachschlagen",
  "nav.notebook": "Notizbuch",
  "taster.title": "Hier endet der kostenlose Teil",
  "taster.body": "Du hast eine Lektion aus diesem Kurs gesehen. Mit einem Abo oeffnest du den ganzen Kurs und alle Pruefungsstufen.",
  "taster.itemBody": "Du hast eine Aufgabe dieser Art ausprobiert. Mit einem Abo oeffnest du den Rest.",
  "taster.cta": "Preise ansehen",
  "taster.free": "Kostenlose Probe",
  "nav.payments": "Zahlungen",
  "tour.body.payments": "Wartende Ueberweisungen. Pruefe jede am Kontoauszug, bevor du sie bestaetigst — eine Bestaetigung schaltet ein echtes Abo frei.",
  "usage.freeConversation": "Dein kostenloses KI-Gespräch",
  "usage.tasterLeft": "Du hast ein kostenloses Gespräch mit dem KI-Partner. Danach brauchen die KI-Funktionen ein Abo.",
  "usage.tasterGone": "Du hast dein kostenloses Gespräch genutzt. Mit einem Abo kannst du weiter mit dem KI-Partner üben.",
  "usage.monthlyResets": "Im Abo enthalten. Wird am 1. jedes Monats zurueckgesetzt - du kannst jederzeit aufladen.",
  "usage.subscribe": "Preise ansehen",
  "usage.spent": "Bisher {tokens} Tokens genutzt, Kosten {amount}.",
  "buy.title": "Discento abonnieren",
  "buy.subtitle": "Alle Kurse und alle Pruefungsstufen, dazu jeden Monat KI inklusive.",
  "buy.pickPeriod": "Wie lange?",
  "buy.period.monthly": "1 Monat",
  "buy.period.quarterly": "3 Monate",
  "buy.period.half_yearly": "6 Monate",
  "buy.period.yearly": "12 Monate",
  "buy.perMonth": "{amount} pro Monat",
  "buy.continue": "Weiter",
  "buy.howToPay": "So bezahlst du",
  "buy.step1": "Ueberweise {amount} mit einer der folgenden Methoden.",
  "buy.step2": "Gib diese Referenz im Verwendungszweck an:",
  "buy.step3": "Sag uns danach die Transaktionsnummer, damit wir deine Zahlung finden.",
  "buy.referenceWhy": "Ohne sie können wir deine Ueberweisung deinem Konto nicht zuordnen.",
  "buy.upi": "UPI",
  "buy.bank": "Bankueberweisung",
  "buy.paypal": "PayPal",
  "buy.accountName": "Kontoinhaber",
  "buy.accountNumber": "Kontonummer",
  "buy.ifsc": "IFSC",
  "buy.utrLabel": "Transaktionsnummer (UTR)",
  "buy.utrPlaceholder": "z. B. 412345678901",
  "buy.submitUtr": "Ich habe bezahlt",
  "buy.waiting": "Danke - wir pruefen deine Zahlung.",
  "buy.waitingBody": "Zahlungen werden von einem Menschen bestaetigt, meist innerhalb eines Tages. Sobald das erledigt ist, bekommst du Zugang.",
  "buy.notConfigured": "Zahlungen sind auf diesem Server noch nicht eingerichtet. Bitte kontaktiere uns.",
  "buy.copied": "Kopiert",
  "approve.title": "Wartende Zahlungen",
  "approve.subtitle": "Pruefe jede Zahlung am Kontoauszug, bevor du sie bestaetigst.",
  "approve.none": "Nichts offen. Alle Zahlungen sind bearbeitet.",
  "approve.who": "Konto",
  "approve.amount": "Betrag",
  "approve.reference": "Referenz",
  "approve.claimed": "Angegebene Zahlung",
  "approve.notReported": "Noch nicht gemeldet",
  "approve.approve": "Bestaetigen",
  "approve.reject": "Ablehnen",
  "approve.noteLabel": "Notiz (optional)",
  "approve.notePlaceholder": "z. B. auf Auszug vom 12. Sept. gesehen",
  "approve.reasonLabel": "Warum lehnst du ab?",
  "approve.reasonPlaceholder": "z. B. keine passende Gutschrift auf dem Auszug",
  "approve.reasonRequired": "Gib einen Grund an, damit die Lernenden wissen, was zu tun ist.",
  "approve.approved": "Bestaetigt - Zugang freigeschaltet.",
  "approve.rejected": "Abgelehnt.",
  "cost.title": "Was die KI kostet",
  "cost.thisMonth": "Diesen Monat",
  "cost.recovered": "Verkaufte Credits",
  "cost.tokens": "{n} Tokens",
  "cost.perLearner": "Kosten pro Lernendem",
  "grace.label": "Kulanzfrist (Tage)",
  "grace.help": "Tage, die der Zugang nach Ablauf des Abos weiterlaeuft. Zahlungen werden von Hand geprueft, ein Wochenende sollte niemanden aussperren. Leer lassen fuer den Standardwert.",
  "reference.basics": "Grundlagen",
  "basics.play": "{what} anhoeren",
  "rewards.title": "Ihre Diamanten",
  "rewards.subtitle": "Verdient für abgeschlossene Arbeit.",
  "rewards.none": "Schließen Sie eine Lektion ab, um den ersten zu verdienen.",
  "rewards.each": "je {n}",
  "rewards.lessons": "Abgeschlossene Lektionen",
  "rewards.teile": "Abgeschlossene Prüfungsteile",
  "rewards.levels": "Abgeschlossene Stufen",
  "basics.playExamples": "Wörter mit {what} anhören",
  "basics.hearThese": "Zum Anhören tippen: {words}",
  "basics.a1Only": "Das sind die Grundlagen für den ersten Tag - auf jeder Stufe dieselben, deshalb stehen sie unter A1.",
  "basics.intro": "Alles hier kannst du antippen und anhoeren. Das ist der Stoff fuer den ersten Tag: das Alphabet, die Zahlen und die Buchstabenkombinationen, die anders klingen, als man denkt.",
  "basics.alphabet": "Das Alphabet",
  "basics.alphabetIntro": "Das sind die Buchstaben-NAMEN - so buchstabierst du deinen Namen. Die brauchst du an jedem Schalter in Deutschland.",
  "basics.extra": "Die vier zusaetzlichen Buchstaben",
  "basics.extraIntro": "Ohne sie kannst du keine deutsche Adresse buchstabieren.",
  "basics.numbers": "Zahlen",
  "basics.tens": "Zehner und mehr",
  "basics.backwards": "21 wird rueckwaerts gesprochen",
  "basics.backwardsIntro": "Im Deutschen kommen die Einer VOR den Zehnern: 21 ist einundzwanzig. Das ueberrascht alle - und im Hoerverstehen ist ein Preis oder eine Uhrzeit oft die ganze Antwort.",
  "basics.sounds": "Laute, die ueberraschen",
  "basics.soundsIntro": "Jeder davon ist ein typischer Anfaengerfehler. Tippe an, um den Unterschied zu hoeren.",
  "sounds.ei": "Klingt wie der Buchstabenname A, nicht wie ie.",
  "sounds.ie": "Ein langes i. Genau umgekehrt zu ei - der zweite Buchstabe gibt den Laut.",
  "sounds.eu": "Klingt wie eu in heute, im Englischen oy.",
  "sounds.ch": "Nach i oder e: weich, wie ein gehauchtes h. Kein k.",
  "sounds.ach": "Nach a, o oder u: hart, hinten im Rachen.",
  "sounds.sch": "Wie sh im Englischen.",
  "sounds.sp": "Am Wortanfang beginnen sp und st mit einem sch-Laut.",
  "sounds.v": "Klingt meist wie f.",
  "sounds.w": "Klingt wie das englische v.",
  "sounds.z": "Immer ts, nie wie das englische z.",
  "sounds.r": "Im Rachen, nicht auf der Zunge. Am Wortende verschwindet es fast.",
  "sounds.er": "Am Wortende klingt es wie ein kurzes a.",
  "approach.title": "So gehst du vor",
  "approach.hoeren.rubric": "Du hoerst jede Aufnahme zweimal, genau wie in der echten Pruefung. Spiel sie ab, beantworte was du kannst, und hoer sie dann noch einmal.",
  "approach.hoeren.questions": "Lies die Fragen, BEVOR du auf Play drueckst. Diese dreissig Sekunden bringen mehr als ein drittes Hoeren - du weisst dann, worauf du achten musst.",
  "approach.hoeren.first": "Beim ersten Hoeren geht es ums Grobverstaendnis. Bleib nicht an einem Wort haengen; waehrend du darueber nachdenkst, laeuft meist genau der Satz mit der Antwort.",
  "approach.hoeren.second": "Beim zweiten Hoeren pruefst du die Antworten, bei denen du unsicher warst. Genau dafuer ist das zweite Abspielen in der Pruefung da.",
  "approach.hoeren.guess": "Lass nie eine Frage leer. Falsche Antworten geben keinen Abzug - zwischen zwei Optionen zu raten bringt im Schnitt ein Drittel Punkt.",
  "approach.lesen.rubric": "Du kannst den Text so oft lesen, wie du willst - in der echten Pruefung hast du die ganze Zeit fuer diesen Teil.",
  "approach.lesen.skim": "Ueberflieg zuerst den ganzen Text, ohne bei unbekannten Woertern stehenzubleiben. Du suchst das Thema, nicht jede Vokabel.",
  "approach.lesen.locate": "Such fuer jede Frage die passende Stelle im Text und lies nur diese Stelle langsam.",
  "approach.lesen.trap": "Achte auf Antworten, die ein Wort aus dem Text wiederholen, aber etwas anderes sagen. Das ist die uebliche Falle - die richtige Antwort umschreibt meist.",
  "approach.lesen.guess": "Lass nie eine Frage leer. Falsche Antworten geben keinen Abzug.",
  "help.title": "Hilfe",
  "help.subtitle": "Wie du Discento nutzt, was jedes Menue macht und die haeufigsten Fragen.",
  "help.howTo": "So lernst du mit Discento",
  "help.howToIntro": "Du musst dich nicht genau daran halten, aber so funktioniert es bei den meisten Lernenden.",
  "help.step.learn.title": "1. Arbeite die Lektionen durch",
  "help.step.learn.body": "Unter Lernen findest du den Kurs fuer dein Niveau, der Reihe nach. Jede Lektion ist kurz und endet mit ein paar Fragen - so merkst du sofort, ob es sitzt.",
  "help.step.practice.title": "2. Ueb die Pruefungsteile",
  "help.step.practice.body": "Ueben bildet die echten telc- und Goethe-Pruefungen ab: Lesen, Hoeren, Schreiben, Sprechen. Nimm dir einen Teil nach dem anderen vor, bevor du eine ganze Modellpruefung machst.",
  "help.step.speak.title": "3. Sprich laut, moeglichst jeden Tag",
  "help.step.speak.body": "Unter Sprechen fuehrst du ein Gespräch mit einem KI-Partner. Genau diesen Teil meiden viele - und genau da kommt man am schnellsten voran. Zwei Minuten am Tag reichen schon.",
  "help.step.ask.title": "4. Frag, sobald du haengst",
  "help.step.ask.body": "Frag nach steht bei jeder Lektion und jeder Uebungsfrage. Schreib in deiner eigenen Sprache - Hindi, Punjabi, Englisch - und die Antwort kommt in dieser Sprache zurueck. Du kannst so lange nachfragen, bis es klar ist.",
  "help.step.track.title": "5. Behalte, was du lernst",
  "help.step.track.body": "Das Notizbuch ist fuer deine eigenen Notizen; im Verlauf stehen alle Fragen und Gespräche - eine gute Erklaerung geht nie verloren.",
  "help.menus": "Was jedes Menue macht",
  "help.menusIntro": "Das sind die Menues in deinem Konto. Die gefuehrte Tour kannst du in deinem Profil noch einmal starten.",
  "help.faq": "Haeufige Fragen",
  "help.faq.credits.q": "Was ist das KI-Guthaben und wofuer wird es verbraucht?",
  "help.faq.credits.a": "Alles, was die KI fuer dich erzeugt: ein Gespräch, eine beantwortete Frage, ein bewerteter Text. Lektionen lesen, Uebungen machen und Audio hoeren kostet nichts. Was eine Antwort kostet, haengt vom gewaehlten KI-Partner ab: der schnellste reicht etwa zwanzigmal so weit wie der teuerste. Dein Abo enthaelt ein monatliches Kontingent, und deine Schule kann jederzeit Guthaben aufladen.",
  "help.faq.voice.q": "Kann ich die Stimme der Audios aendern?",
  "help.faq.voice.a": "Ja - maennlich oder weiblich, in deinen Profileinstellungen. Das gilt fuer die Hoertexte und den Sprachpartner. Hoertexte mit zwei Personen werden von beiden Stimmen gelesen, wie in der echten Pruefung.",
  "help.faq.offline.q": "Funktioniert das auf dem Handy?",
  "help.faq.offline.a": "Ja, jede Seite ist fuers Handy gebaut. Du brauchst eine Internetverbindung - es wird nichts zum Offline-Lernen heruntergeladen.",
  "help.faq.level.q": "Ich weiss nicht, welches Niveau ich habe. Wo fange ich an?",
  "help.faq.level.a": "Mach den Einstufungstest auf deinem Dashboard. Ein paar kurze Fragen, und du bekommst eine Empfehlung - ein Startpunkt, kein Urteil. Aendern kannst du sie jederzeit.",
  "help.faq.exam.q": "Ist das die echte telc- oder Goethe-Pruefung?",
  "help.faq.exam.a": "Nein. Wir bilden Aufbau, Teile und Zeiten nach, damit dich die echte Pruefung nicht ueberrascht - die Pruefung selbst legst du in einem offiziellen Zentrum ab.",
  "help.faq.notes.q": "Wie mache ich Text in meinen Notizen fett oder markiert?",
  "help.faq.notes.a": "Markiere die Woerter und druecke B oder H im Notizfeld - oder Strg+B und Strg+H. Eine Vorschau unter dem Feld zeigt, wie die Notiz aussehen wird.",
  "help.faq.history.q": "Wo landen meine alten Fragen und Gespräche?",
  "help.faq.history.a": "Im Verlauf, direkt neben dem Notizbuch. Dort steht alles, was du und die KI gesagt habt, und du kannst eine Frage wieder oeffnen und weiterfragen.",
  "help.faq.mobile.q": "Das Mikrofon hat aufgehoert zuzuhoeren, waehrend ich nachgedacht habe.",
  "help.faq.mobile.a": "Sollte es nicht - Pausen sind normal und das Mikrofon hoert weiter zu. Falls es doch stoppt, lade die Seite neu und starte erneut; deine beendeten Gespräche sind im Verlauf sicher.",
  "briefing.prepTitle": "Mach dir zuerst Notizen",
  "briefing.prepBody": "In der echten Pruefung hast du 20-30 Minuten Zeit fuer die Aufgabe, bevor du sprichst. Lies sie in Ruhe und notiere deine Stichpunkte - sobald das Gespräch beginnt, laeuft es im Pruefungstempo.",
  "briefing.title": "So funktioniert es",
  "briefing.speak.title": "Einfach sprechen",
  "briefing.speak.body": "Das Mikrofon hoert von selbst zu. Verabschiede dich oder druecke Beenden, wenn du fertig bist.",
  "briefing.turns.title": "Abwechselnd sprechen",
  "briefing.turns.body": "Warte, bis der Partner fertig ist, und antworte dann ganz normal - wie bei einem Menschen.",
  "briefing.pause.title": "Pausen sind in Ordnung",
  "briefing.done.title": "Satz fertig? Tipp auf Fertig",
  "briefing.done.body": "Der Partner antwortet von selbst nach einer kurzen Stille. Wenn es schneller gehen soll, tipp auf Fertig.",
  "briefing.pause.body": "Ueberlege so lange du willst. Das Mikrofon hoert auch bei Stille weiter zu und unterbricht dich nicht.",
  "briefing.trouble.title": "Wenn etwas nicht klappt",
  "briefing.trouble.body": "Lade die Seite neu und starte erneut. Deine beendeten Gespräche findest du im Verlauf.",
  "nav.history": "Verlauf",
  "history.title": "Verlauf",
  "history.subtitle": "Alle Fragen und Gespräche mit der KI an einem Ort.",
  "history.filter.all": "Alles",
  "history.filter.doubt": "Fragen",
  "history.filter.speaking": "Gespräche",
  "history.kind.doubt": "Frage",
  "history.kind.speaking": "Gespräch",
  "history.conversation": "Gespräch",
  "history.turns": "{count} Nachrichten",
  "history.empty": "Noch nichts hier. Stelle eine Frage in einer Lektion oder sprich mit dem Sprachpartner — alles wird hier gespeichert.",
  "history.delete": "Loeschen",
  "history.you": "Du",
  "history.ai": "KI-Tutor",
  "doubt.conversation": "Dein Gespräch",
  "doubt.followUp": "Nachfragen",
  "doubt.followUpPlaceholder": "Noch unklar? Frag noch einmal...",
  "doubt.newQuestion": "Neue Frage",
  "doubt.saved": "Im Verlauf gespeichert",
  "notebook.tabNotes": "Notizen",
  "notebook.tabWriting": "Schreibuebung",
  "writing.intro": "Schreiben Sie etwas auf Deutsch, und der Coach korrigiert es - mit Punktzahl, den wichtigsten Korrekturen und dem naechsten Uebungsschritt. Was Sie moechten: Tagebuch, E-Mail, Meinung.",
  "writing.level": "Niveau",
  "writing.levelHint": "Woran gemessen wird.",
  "writing.topic": "Thema",
  "writing.topicHint": "optional",
  "writing.topicPlaceholder": "z. B. mein Wochenende, mein Beruf",
  "writing.yourText": "Ihr Text",
  "writing.placeholder": "Schreiben Sie hier auf Deutsch...",
  "writing.words": "Wörter",
  "writing.submit": "Feedback erhalten",
  "writing.past": "Fruehere Texte",
  "writing.corrections": "Korrekturen",
  "writing.improvements": "Verbesserungspotenzial",
  "writing.whatYouWrote": "Ihr Text",
  "writing.again": "Neuen Text schreiben",
  "writing.noFeedback": "Fuer diesen Text wurde kein Feedback gespeichert.",
  "writing.notConfigured": "Der KI-Schreibcoach ist auf diesem Server noch nicht aktiviert — bitte wenden Sie sich an Ihre Administration.",
  "notebook.moveTo": "In Tab verschieben",
  "notebook.bold": "Fett",
  "notebook.italic": "Kursiv",
  "notebook.highlight": "Markieren",
  "notebook.formatHint": "Text markieren, dann B, I oder H",
  "notebook.preview": "Vorschau",
  "notebook.allNotes": "Allgemein",
  "notebook.newSection": "+ neuer Tab",
  "notebook.source": "Aus einer Lektion gespeichert",
  "placement.title": "Wo sollten Sie anfangen?",
  "placement.subtitle": "Ein paar Fragen, die leichteste zuerst. Antworten Sie, was Sie können, und lassen Sie den Rest aus - genau darum geht es.",
  "placement.progress": "Frage {current} von {total}",
  "placement.next": "Weiter",
  "placement.back": "Zurueck",
  "placement.finish": "Mein Niveau anzeigen",
  "placement.dontKnowHint": "Unsicher? Lassen Sie die Frage aus - Raten hilft bei der Einstufung nicht.",
  "placement.noQuestions": "Es sind noch keine Einstufungsfragen verfuegbar.",
  "placement.skipQuestion": "Diese Frage kann nicht angezeigt werden - bitte weiter.",
  "placement.startHere": "Hier anfangen",
  "placement.reasonNext": "Die Niveaus darunter haben Sie sicher gemeistert - hier sollte Ihr Kurs beginnen.",
  "placement.reasonBeginner": "Wir beginnen ganz vorne. Das ist fuer die meisten richtig - die ersten Lektionen gehen schnell, wenn Sie schon etwas Deutsch können.",
  "placement.reasonTop": "Sie haben alles beantwortet. Das ist das hoechste Niveau, das wir derzeit unterrichten.",
  "placement.startLearning": "Kurs starten",
  "placement.goPractice": "Uebungsaufgaben ausprobieren",
  "notebook.saveHere": "In mein Notizbuch",
  "notebook.saveTitle": "Im Notizbuch behalten",
  "notebook.saveFrom": "Aus {lesson} - Ihre Notiz verlinkt hierher zurueck.",
  "notebook.savePlaceholder": "Markieren Sie zuerst Text auf der Seite, oder tippen Sie ihn hier",
  "notebook.saved": "Im Notizbuch gespeichert.",
  "levels.title": "Ihre Niveaus",
  "levels.lessons": "{done}/{total} Lektionen",
  "levels.practice": "{done}/{total} Uebungsteile",
  "levels.markComplete": "Als abgeschlossen markieren",
  "levels.done": "Abgeschlossen",
  "levels.undo": "Rueckgaengig",
  "levels.keepGoing": "Weiter so",
  "levels.wellDone": "{level} abgeschlossen - gut gemacht.",
  "notebook.title": "Mein Notizbuch",
  "notebook.subtitle": "Ein privater Notizblock für Regeln, Wörter und Fragen — nur Sie sehen ihn.",
  "notebook.placeholder": "Notiz schreiben…",
  "notebook.add": "Notiz hinzufügen",
  "notebook.edit": "Bearbeiten",
  "notebook.delete": "Löschen",
  "notebook.empty": "Noch keine Notizen. Schreiben Sie oben Ihre erste.",
  "reference.title": "Nachschlagewerk",
  "reference.subtitle": "Grammatikregeln, Tabellen und Wortschatz für jedes Niveau — jederzeit zum Nachschlagen.",
  "reference.grammar": "Grammatik",
  "reference.vocab": "Wortschatz",
  "reference.tables": "Tabellen",
  "reference.rules": "Regeln",
  "reference.search": "Suchen…",
  "reference.noResults": "Keine Treffer für Ihre Suche.",
  "reference.unavailable": "Dieser Teil der Bibliothek konnte nicht geladen werden. Bitte versuchen Sie es gleich noch einmal.",
  "reference.noLevels": "Auf diesem Server wurde noch kein Referenzmaterial veröffentlicht.",
  "reference.wordCount": "{count} Wörter auf diesem Niveau",
  "review.tab": "Wiederholen",
  "review.due": "{count} heute fällig",
  "review.learned": "{count} von {total} gelernt",
  "review.sessionDone": "Runde geschafft",
  "review.reviewed": "Sie haben {count} Wörter wiederholt.",
  "review.again": "Weiter wiederholen",
  "review.position": "{n} von {total}",
  "review.newWord": "Neues Wort",
  "review.box": "Fach {box}",
  "review.reveal": "Bedeutung zeigen",
  "review.plural": "Plural",
  "review.forgot": "Nicht gewusst",
  "review.knew": "Gewusst",
  "review.empty": "Im Moment gibt es nichts zu wiederholen.",
  "kc.title": "Ihr Können-Check",
  "kc.doNext": "Das kommt als Nächstes",
  "kc.notStarted": "noch nicht begonnen",
  "kc.needMore": "noch {count} bis zur Auswertung",
  "kc.overallLocked": "noch {count} Fertigkeiten bis zur Gesamtnote",
  "kc.action.review_vocab": "{count} fällige Wörter wiederholen",
  "kc.action.start_skill": "{skill} beginnen — {count} Aufgaben schalten Ihre Bewertung frei",
  "kc.action.finish_evidence": "Noch {count} in {skill} bis zur Bewertung",
  "kc.action.improve_skill": "{skill} verbessern — zurzeit {count}%",
  "skill.wortschatz": "Wortschatz",
  "skill.grammatik": "Grammatik",
  "skill.lesen": "Lesen",
  "skill.hoeren": "Hören",
  "skill.schreiben": "Schreiben",
  "skill.sprechen": "Sprechen",
  "nav.team": "Team",
  "nav.access": "Zugriff",
  "nav.tenants": "Mandanten",
  "nav.billing": "Abrechnung",
  "nav.revenue": "Umsatz",
  "nav.profile": "Mein Konto",

  "profile.title": "Mein Konto",
  "profile.subtitle": "Aktualisieren Sie Ihre Daten und Ihr Passwort.",
  "profile.details": "Profildaten",
  "profile.fullName": "Vollständiger Name",
  "profile.phone": "Telefon",
  "profile.voice": "Stimme",
  "profile.voiceHint": "Die Stimme fuer den Sprechpartner und die Hoeruebungen.",
  "profile.language": "Sprache",
  "profile.emailLocked": "Wenden Sie sich an den Support, um Ihre E-Mail-Adresse zu ändern.",
  "profile.saved": "Profil aktualisiert.",
  "profile.password.title": "Passwort",
  "profile.password.current": "Aktuelles Passwort",
  "profile.password.new": "Neues Passwort",
  "profile.password.confirm": "Neues Passwort bestätigen",
  "profile.password.submit": "Passwort ändern",
  "profile.password.mismatch": "Die neuen Passwörter stimmen nicht überein.",
  "profile.password.changed": "Passwort geändert.",
  "profile.aiUsage": "KI-Nutzung",
  "twofa.title": "Zwei-Faktor-Authentifizierung",
  "twofa.on": "Zwei-Faktor-Authentifizierung ist aktiv",
  "twofa.off": "Fügen Sie beim Login einen zweiten Schritt für mehr Sicherheit hinzu.",
  "twofa.enable": "Aktivieren",
  "twofa.disable": "Deaktivieren",
  "twofa.disabled": "Zwei-Faktor-Authentifizierung deaktiviert.",
  "twofa.code": "Code aus Ihrer App",
  "twofa.scanIntro": "Scannen Sie dies mit Ihrer Authenticator-App und geben Sie zur Bestätigung den 6-stelligen Code ein.",
  "twofa.manualKey": "Können Sie nicht scannen? Geben Sie diesen Schlüssel manuell ein:",
  "twofa.recoveryIntro": "Bewahren Sie diese Wiederherstellungscodes sicher auf — jeder funktioniert einmal, falls Sie Ihr Gerät verlieren. Sie werden nicht erneut angezeigt.",
  "twofa.done": "Fertig",
  "twofa.disableIntro": "Geben Sie einen aktuellen Code (oder einen Wiederherstellungscode) ein, um die Zwei-Faktor-Authentifizierung zu deaktivieren.",
  "usage.today": "Heute",
  "usage.thisWeek": "Diese Woche",
  "usage.thisMonth": "Diesen Monat",
  "usage.left": "{pct}% übrig",
  "usage.used": "{used} von {limit} verbraucht",
  "usage.learners": "KI-Nutzung nach Lernenden",
  "usage.tenants": "KI-Nutzung nach Mandant",
  "usage.tokensThisMonth": "Tokens diesen Monat",
  "usage.none": "Noch keine KI-Nutzung.",
  "usage.cost": "Kosten",
  "usage.aiCost": "KI-Kosten diesen Monat",
  "usage.toppedUp": "Aufladungen",
  "usage.margin": "Marge diesen Monat",
  "nav.aiUsage": "KI-Nutzung",
  "nav.group.learn": "Lernen",
  "nav.group.practice": "Ueben",
  "nav.group.school": "Schule",
  "nav.group.account": "Konto",
  "nav.group.revenue": "Umsatz",
  "nav.group.platform": "Mandanten",
  "nav.group.ai": "KI",
  "nav.menu": "Menü",
  "nav.closeMenu": "Menü schließen",
  "nav.switchLanguage": "Sprache wechseln",
  "nav.notifications": "Benachrichtigungen",
  "nav.logout": "Abmelden",

  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.login": "Anmelden",
  "auth.login.title": "Willkommen zurück",
  "auth.2fa.title": "Zwei-Faktor-Authentifizierung",
  "auth.2fa.subtitle": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein (oder einen Wiederherstellungscode).",
  "auth.2fa.code": "Authentifizierungscode",
  "auth.2fa.verify": "Bestätigen",
  "auth.login.subtitle": "Melden Sie sich in Ihrem Arbeitsbereich an",
  "auth.forgot": "Passwort vergessen?",
  "auth.forgot.title": "Passwort zurücksetzen",
  "auth.forgot.subtitle": "Wir senden Ihnen einen Link per E-Mail.",
  "auth.forgot.submit": "Link senden",
  "auth.reset.title": "Neues Passwort wählen",
  "auth.reset.password": "Neues Passwort",
  "auth.reset.submit": "Passwort speichern",
  "auth.reset.done": "Passwort gespeichert. Sie können sich jetzt anmelden.",
  "auth.invite.title": "Konto einrichten",
  "auth.invite.for": "Sie richten das Konto ein für",
  "auth.invite.submit": "Konto aktivieren",
  "auth.backToLogin": "Zurück zur Anmeldung",
  "auth.name": "Ihr Name",
  "auth.signup.title": "Konto erstellen",
  "auth.signup.subtitle": "Fangen Sie an, Deutsch zu lernen — den Tarif wählen Sie später, nicht jetzt.",
  "auth.createAccount": "Konto erstellen",
  "auth.passwordHint": "Mindestens 8 Zeichen.",
  "auth.haveAccount": "Sie haben schon ein Konto?",
  "auth.newHere": "Neu hier?",
  "onboarding.title": "Lassen Sie uns starten",
  "onboarding.subtitle": "Fünf kurze Fragen, damit wir Ihnen das richtige Niveau und den passenden Plan zeigen können. Was Sie kaufen, entscheiden Sie später.",
  "onboarding.stepOf": "Schritt {n} von {total}",
  "onboarding.back": "Zurück",
  "onboarding.next": "Weiter",
  "onboarding.finish": "Meine Empfehlung ansehen",
  "onboarding.q.goal": "Warum lernen Sie Deutsch?",
  "onboarding.q.board": "Welche Prüfung haben Sie im Blick?",
  "onboarding.q.level": "Wie viel Deutsch können Sie schon?",
  "onboarding.q.focus": "Auf welches Niveau möchten Sie sich jetzt konzentrieren?",
  "onboarding.q.timeline": "Wie viel Zeit können Sie investieren?",
  "onboarding.goal.exam": "Eine Prüfung bestehen",
  "onboarding.goal.work": "Beruf & Karriere",
  "onboarding.goal.study": "Studium",
  "onboarding.goal.immigration": "Leben in Deutschland",
  "onboarding.goal.travel": "Reisen & Privat",
  "onboarding.board.telc": "telc",
  "onboarding.board.goethe": "Goethe",
  "onboarding.board.either": "Noch unsicher",
  "onboarding.level.none": "Kompletter Anfänger",
  "onboarding.level.A1": "A1 — einfache Sätze",
  "onboarding.level.A2": "A2 — Alltagsgrundlagen",
  "onboarding.level.B1": "B1 — selbstständig",
  "onboarding.level.B2": "B2 — sicher",
  "onboarding.level.C1": "C1 — fortgeschritten",
  "onboarding.quickCheck": "Unsicher? Hilfe bei der Wahl",
  "onboarding.quickCheck.q": "Was trifft am besten auf Sie zu?",
  "onboarding.quick.none": "Ich fange gerade erst an.",
  "onboarding.quick.A1": "Ich kann mich vorstellen und Essen bestellen.",
  "onboarding.quick.A2": "Ich kann über meinen Tag und Vergangenes sprechen.",
  "onboarding.quick.B1": "Ich komme auf Reisen zurecht und kann meine Meinung erklären.",
  "onboarding.quick.B2": "Ich kann mühelos über abstrakte Themen sprechen.",
  "onboarding.quick.C1": "Ich drücke mich fließend zu komplexen Themen aus.",
  "onboarding.timeline.relaxed": "Entspannt — etwas pro Woche",
  "onboarding.timeline.steady": "Regelmäßig — mehrmals pro Woche",
  "onboarding.timeline.intensive": "Intensiv — fast täglich",
  "dashboard.rec.eyebrow": "Ihre Empfehlung",
  "dashboard.rec.headline": "Wir empfehlen {level} — Komplett",
  "dashboard.rec.cta": "Ihren Plan ansehen",
  "dashboard.rec.bothBoards": "telc und Goethe",
  "dashboard.rec.credits": "Plus KI-Guthaben für Schreib- und Sprechfeedback.",
  "dashboard.rec.reason.exam": "Sie bereiten sich auf eine Prüfung vor — Komplett verbindet den {level}-Kurs mit vollständigen {board}-Prüfungsübungen und KI-Feedback, das Ihr Schreiben und Sprechen bewertet.",
  "dashboard.rec.reason.work": "Für den Beruf baut Komplett Ihr {level} von Grund auf auf — Kurs, prüfungsnahe Übungen und KI-Feedback.",
  "dashboard.rec.reason.study": "Fürs Studium führt Komplett Sie systematisch durch {level} — Kurs, Übungen im {board}-Format und KI-Feedback.",
  "dashboard.rec.reason.immigration": "Für das Leben in Deutschland deckt Komplett {level} ab — vom Alltagswortschatz bis zur {board}-Prüfung, mit KI-Feedback.",
  "dashboard.rec.reason.travel": "Komplett gibt Ihnen ein solides {level} — Kurs, Übungen und KI-Feedback, damit es sitzt.",

  "dashboard.greeting.morning": "Guten Morgen",
  "dashboard.greeting.day": "Guten Tag",
  "dashboard.greeting.evening": "Guten Abend",
  "dashboard.subtitle": "Das passiert gerade in Ihrem Arbeitsbereich.",
  "dashboard.admin.tenants": "Schulen, Plätze und Module verwalten.",
  "dashboard.admin.orders": "Überweisungsbestellungen, die auf Bestätigung warten.",
  "dashboard.admin.revenue": "Zahlungen und Umsatz über alle Mandanten.",
  "dashboard.admin.ai": "KI-Anbieter auswählen und Schlüssel verwalten.",

  "team.title": "Team",
  "team.invite": "Mitglied einladen",
  "team.invite.title": "Teammitglied einladen",
  "team.invite.name": "Vollständiger Name",
  "team.invite.role": "Rolle",
  "team.invite.submit": "Einladung senden",
  "team.resend": "Einladung erneut senden",
  "team.deactivate": "Deaktivieren",
  "team.activate": "Aktivieren",
  "team.status.active": "Aktiv",
  "team.status.inactive": "Inaktiv",
  "team.status.invited": "Eingeladen",

  "access.title": "Zugriff",
  "access.subtitle": "Berechtigungen über die Rolle hinaus erteilen oder entziehen.",
  "access.domain": "Bereich",
  "access.read": "Lesen",
  "access.write": "Schreiben",
  "access.granted": "erteilt",
  "access.revoked": "entzogen",
  "access.default": "Rollenstandard",

  "tenants.title": "Mandanten",
  "tenants.provision": "Neuer Mandant",
  "tenants.provision.title": "Mandant anlegen",
  "tenants.legalName": "Firmenname",
  "tenants.subdomain": "Subdomain",
  "tenants.tier": "Tarif",
  "tenants.adminEmail": "Admin-E-Mail",
  "tenants.adminName": "Admin-Name",
  "tenants.provision.submit": "Anlegen",
  "tenants.provisioned": "Mandant angelegt. Einladungslink (auch per E-Mail):",
  "tenants.levels": "Niveaus, die diese Schule gekauft hat",
  "tenants.levelsHint": "Jedes Niveau fügt seinen Kurs und seine Prüfungsübungen hinzu. Später auf der Schulseite änderbar.",
  "tenants.levelsAll": "Alle auswählen",
  "tenants.levelsNone": "Zurücksetzen",
  "tenants.provisionedNoEmail": "Schule angelegt. E-Mail ist auf diesem Server nicht konfiguriert — senden Sie diesen Link bitte selbst an die Administration:",
  "tenants.seats": "Plätze",
  "tenants.modules": "Module",
  "tenants.active": "Aktiv",
  "tenants.inactive": "Inaktiv",
  "tenants.seatPreview": "{n} Nutzer würden durch diese Änderung deaktiviert.",
  "tenants.save": "Änderungen speichern",
  "tenants.access": "Zugang und Kulanzfrist",
  "tenants.paidUntil": "Bezahlt bis",
  "tenants.neverPaid": "Noch nicht bezahlt",
  "tenants.graceDays": "Kulanztage",
  "tenants.graceDefault": "Standard der Plattform",
  "tenants.graceHelp": "Tage Zugang nach Ablauf des bezahlten Zeitraums. Leer lassen, um den Standard der Plattform zu verwenden. Überweisungen werden von Hand geprüft - das ist der Puffer zwischen Geldeingang und Freigabe.",
  "tenants.saveGrace": "Kulanzfrist speichern",

  "notifications.title": "Benachrichtigungen",
  "notifications.empty": "Alles erledigt.",
  "notifications.markAll": "Alle als gelesen markieren",

  "nav.learn": "Der Kurs",
  "learn.title": "Kurse",
  "learn.subtitle": "Ihr Deutschkurs, Stufe für Stufe.",
  "learn.enroll": "Einschreiben",
  "learn.enrolled": "Eingeschrieben",
  "learn.continue": "Weitermachen, wo Sie aufgehört haben",
  "learn.resume": "Fortsetzen",
  "learn.start": "Starten",
  "learn.review": "Wiederholen",
  "learn.completed": "Abgeschlossen",
  "learn.lessons": "Lektionen",
  "learn.mastery": "Beherrschung",
  "learn.xp": "XP",
  "learn.empty": "Noch keine Kurse veröffentlicht.",
  "nav.practice": "Pruefungsuebung",
  "nav.speak": "Sprechen",
  "bot.title": "Sprachpartner",
  "bot.subtitle": "Sprechen Sie frei mit Ihrem KI-Partner — er bleibt, bis Sie aufhören.",
  "bot.intro": "Einmal starten, dann einfach sprechen. Ihr Partner hört zu, antwortet laut, und das Mikrofon schaltet sich von selbst wieder ein — keine Tasten zwischendurch. Beenden Sie das Gespräch, wann Sie möchten, und Sie erhalten eine Rückmeldung.",
  "bot.language": "Sprache",
  "bot.level": "Niveau",
  "bot.levelAuto": "Automatisch (an mich anpassen)",
  "bot.levelAutoHint": "Wir wählen ein Niveau, sobald wir Ihr Sprechen kennen.",
  "bot.levelAutoAt": "Anhand Ihrer letzten Gespräche starten wir etwa bei {level}.",
  "bot.topic": "Thema",
  "bot.topicHint": "optional — leer lassen für ein freies Gespräch",
  "bot.howTitle": "So funktioniert es",
  "bot.howSpeak": "Sprechen Sie einfach - das Mikrofon ist schon an. Zwischen den Zuegen druecken Sie nichts.",
  "bot.howPause": "Lassen Sie sich Zeit. Nachdenken ist in Ordnung, es hoert weiter zu.",
  "bot.howStuck": "Fehlt Ihnen ein Wort? Sagen Sie es auf Englisch, oder tippen Sie unten.",
  "bot.howEnd": "Druecken Sie Beenden, wenn Sie genug haben - dann bekommen Sie Feedback.",
  "bot.partnerSpeaking": "Ihr Partner spricht...",
  "bot.voice": "Stimme",
  "bot.voiceHintServer": "maennlich oder weiblich - im Konto gespeichert, also auf jedem Geraet gleich",
  "bot.voiceMale": "Maennliche Stimme",
  "bot.voiceFemale": "Weibliche Stimme",
  "bot.voiceHint": "optional — manche Stimmen klingen deutlich natürlicher",
  "bot.voiceAuto": "Beste verfügbare",
  "bot.voiceTest": "Anhören",
  "bot.past": "Frühere Gespräche",
  "bot.backToStart": "Zurück",
  "bot.resumed": "Dort weiter, wo Sie aufgehört haben. Drücken Sie weiter, wenn Sie sprechen möchten.",
  "bot.continue": "Weitersprechen",
  "bot.topicPlaceholder": "z. B. Reisen, mein Beruf, Essen …",
  "bot.start": "Gespräch starten",
  "bot.end": "Beenden & Feedback erhalten",
  "practice.title": "Übungszentrum",
  "practice.status.preparingFor": "Sie bereiten sich vor auf",
  "practice.status.updateGoal": "Ziel ändern",
  "practice.status.nextUp": "Als Nächstes",
  "practice.status.noGoal": "Nennen Sie uns Ihr Ziel, um Ihr Üben zu personalisieren.",
  "practice.status.setGoal": "Ziel festlegen",
  "practice.status.goal.exam": "Wir machen Sie fit für die Prüfung.",
  "practice.status.goal.work": "Deutsch für Ihren Beruf.",
  "practice.status.goal.study": "Deutsch für Ihr Studium.",
  "practice.status.goal.immigration": "Deutsch für das Leben in Deutschland.",
  "practice.status.goal.travel": "Deutsch für Reisen.",
  "practice.subtitle": "Üben Sie jeden Prüfungsteil im echten Format.",
  "practice.practices": "Übungen",
  "practice.progress": "Fortschritt",
  "practice.start": "Übung starten",
  "practice.submit": "Abgeben",
  "practice.result": "Ergebnis",
  "practice.tryAgain": "Noch einmal",
  "practice.backToPart": "Zurück zu den Übungen",
  "practice.yourAnswer": "Ihre Antwort",
  "practice.correctAnswer": "Richtige Antwort",
  "practice.true": "Richtig",
  "practice.false": "Falsch",
  "practice.choose": "Auswählen…",
  "practice.best": "Beste",
  "practice.filter.all": "Alle",
  "practice.filter.notStarted": "Nicht begonnen",
  "practice.filter.keepPracticing": "Weiter üben",
  "practice.filter.mastered": "Gemeistert",
  "practice.readyToStart": "Bereit zum Start",
  "practice.practicedLabel": "Geübt",
  "practice.mastery": "Beherrschung",
  "practice.search": "Übungen suchen…",
  "practice.minutes": "Min.",
  "practice.howToApproach": "So gehen Sie vor",
  "practice.unanswered": "{n} noch offen",
  "practice.allAnswered": "Alle beantwortet",
  "practice.exam.cta": "Vollständige Prüfungssimulation",
  "practice.exam.ctaBody": "Absolvieren Sie die komplette Prüfung auf Zeit und erhalten Sie eine Auswertung pro Prüfungsteil.",
  "practice.exam.start": "Prüfung starten",
  "practice.exam.introBody": "{sections} Teile · ca. {minutes} Min. · {questions} Aufgaben. Lesen, Sprachbausteine und Hören werden sofort bewertet; Schreiben und Sprechen üben Sie separat.",
  "practice.exam.begin": "Prüfung beginnen",
  "practice.exam.allowed": "Erlaubt: {minutes} Min.",
  "practice.exam.finish": "Abgeben & bewerten",
  "practice.exam.passed": "Bestanden",
  "practice.exam.notPassed": "Weiter üben",
  "practice.exam.bySection": "Nach Prüfungsteil",
  "practice.exam.note": "Schreiben und Sprechen üben Sie separat mit den KI-Coaches.",
  "practice.exam.retake": "Neue Prüfung",
  "practice.exam.history": "Ihre letzten Versuche",
  "practice.readiness.label": "Prüfungsbereitschaft",
  "practice.readiness.detail": "{practiced} von {total} Aufgaben geübt",
  "practice.readiness.review": "Fehler wiederholen",
  "practice.readiness.avgLabel": "Bisheriger Durchschnitt",
  "practice.readiness.needMore": "Üben Sie {count} weitere Aufgaben für eine Einschätzung Ihrer Prüfungsbereitschaft.",
  "practice.readiness.needSections": "Noch nicht begonnen: {sections}",
  "practice.readiness.band.needsWork": "Noch üben",
  "practice.readiness.band.onTrack": "Auf Kurs",
  "practice.readiness.band.examReady": "Prüfungsbereit",
  "practice.review.subtitle": "Aufgaben, die Sie noch nicht gemeistert haben — die schwächsten zuerst. Üben Sie sie erneut, um Ihre Bereitschaft zu steigern.",
  "practice.review.empty": "Nichts zu wiederholen — alle versuchten Aufgaben sind gemeistert. Super!",
  "practice.explain.get": "KI-Erklärung erhalten",
  "practice.explain.notConfigured": "KI-Erklärungen sind auf diesem Server noch nicht aktiviert.",
  "practice.exam.band.sehrGut": "Sehr gut",
  "practice.exam.band.gut": "Gut",
  "practice.exam.band.bestanden": "Bestanden",
  "practice.exam.band.nichtBestanden": "Noch nicht",
  "practice.allThemes": "Alle Themen",
  "practice.previous": "Zurück",
  "practice.next": "Weiter",
  "practice.pageOf": "Seite {page} von {total}",

  "writing.aiCoach": "KI-Schreibcoach",
  "writing.getFeedback": "KI-Feedback erhalten",
  "writing.feedback": "KI-Feedback",
  "writing.levelEstimate": "Niveau-Einschätzung",
  "writing.content": "Inhalt",
  "writing.structure": "Aufbau & Ton",
  "writing.language": "Sprachliche Richtigkeit",
  "writing.taskPoints": "Leitpunkte",
  "writing.strengths": "Stärken",
  "writing.revise": "Überarbeiten & erneut senden",
  "writing.draftNote": "Notizen",
  "writing.draftNoteHint": "Ideen sammeln — wird nicht bewertet",
  "writing.previous": "Frühere Rückmeldungen",
  "writing.quotaUsed": "KI-Feedback diesen Monat: {used} / {limit}",

  "speaking.done": "Fertig",
  "speaking.transcribing": "Verstanden — ich schreibe auf, was du gesagt hast…",
  "speaking.missed": "Das habe ich nicht verstanden — bitte sag es noch einmal.",
  "speaking.wellSaid": "Gut gesagt",
  "speaking.betterLabel": "Besser:",
  "speaking.aiPartner": "KI-Sprechpartner",
  "speaking.notConfigured": "Der KI-Sprechpartner ist auf diesem Server noch nicht aktiviert — bitte wenden Sie sich an Ihre Administration.",
  "live.title": "Live-Sprechen",
  "live.intro": "Sprich laut und bekomme laut Antwort, in Echtzeit - ohne Tippen, ohne Warten. Abgerechnet pro Minute, solange das Gespraech laeuft.",
  "live.balance": "Dein KI-Guthaben",
  "live.fromBalance": "Live-Sprechen wird vom KI-Guthaben bezahlt, nicht vom monatlich enthaltenen Kontingent - dein schriftliches Ueben bleibt also unberuehrt.",
  "live.choose": "Stimme waehlen",
  "live.perMinute": "{price}/Min.",
  "live.affords": "Etwa {minutes} Min. mit deinem Guthaben",
  "live.start": "Sprechen beginnen",
  "live.connecting": "Verbindung wird aufgebaut - bitte das Mikrofon erlauben.",
  "live.listening": "Live - sprich einfach",
  "live.timeLeft": "Verbleibende Zeit in diesem Gespraech. Es endet von selbst, und berechnet wird nur, was du nutzt.",
  "live.stop": "Gespraech beenden",
  "live.spent": "Gespraech nach {time} beendet. Es hat {amount} gekostet, der Rest ging zurueck auf dein Guthaben.",
  "live.topUpNeeded": "Fuer Live-Sprechen brauchst du etwas KI-Guthaben. Lade auf, dann kann es sofort losgehen.",
  "live.notConfigured": "Live-Sprechen ist auf diesem Server noch nicht aktiviert.",
  "live.unavailable": "Live-Sprechen ist in deinem Tarif nicht enthalten.",
  "partner.using": "Antwortet: {name} · {price} pro Gespräch.",
  "partner.change": "Ändern",
  "profile.partner": "KI-Lernpartner",
  "profile.partnerHint": "Wer deine Fragen beantwortet und mit dir Deutsch übt. Ein günstigerer Partner lässt dein KI-Guthaben weiter reichen, ein teurerer ist bei schwierigen Erklärungen etwas besser. Deine Wahl gilt überall.",
  "profile.partnerDefault": "Empfohlenen Partner verwenden",
  "profile.partnerSaved": "Lernpartner gespeichert.",
  "partner.label": "Üben mit",
  "partner.perConversation": "pro Gespräch",
  "partner.locked": "Beenden Sie dieses Gespräch, um den Partner zu wechseln.",
  "speaking.micUnavailable": "Spracheingabe ist in diesem Browser nicht verfügbar — Sie können Ihre Antworten stattdessen tippen.",
  "speaking.start": "Gespräch starten",
  "orb.speaking": "Ihr Partner spricht",
  "orb.listening": "Sie sind dran - sprechen Sie, wenn Sie bereit sind",
  "orb.thinking": "Denkt nach...",
  "orb.idle": "Bereit",
  "speaking.listening": "Ich höre zu…",
  "speaking.thinking": "Denke nach…",
  "speaking.typeFallback": "Antwort tippen",
  "speaking.send": "Senden",
  "speaking.end": "Beenden & Feedback erhalten",
  "speaking.turns": "Runde {turns} von {max}",
  "speaking.turnsWord": "Runden",
  "speaking.quotaUsed": "KI-Gespräche diesen Monat: {used} / {limit}",
  "speaking.feedback": "Gesprächs-Feedback",
  "speaking.interaction": "Interaktion & Aufgabe",
  "speaking.vocabulary": "Wortschatz",
  "speaking.grammar": "Grammatik",
  "speaking.transcript": "Protokoll",
  "speaking.tooShort": "Das Gespräch war zu kurz für eine Bewertung — versuchen Sie beim nächsten Mal ein längeres Gespräch.",
  "speaking.previous": "Frühere Gespräche",
  "speaking.you": "Sie",
  "speaking.partner": "Partner",

  "billing.title": "Abrechnung",
  "billing.subtitle": "Ihr Tarif, Ihre Plätze und Ihre Zahlungshistorie.",
  "billing.notConfigured": "Online-Zahlung ist auf diesem Server noch nicht aktiviert — bitte kontaktieren Sie uns für Ihren Tarif.",
  "billing.currentPlan": "Aktueller Tarif",
  "billing.trial": "Testphase",
  "billing.seats": "Plätze",
  "billing.renewsUntil": "Bezahlt bis",
  "billing.daysLeft": "Tage übrig",
  "billing.inGrace": "Ihr Abo ist abgelaufen. Der Zugang bleibt bis {date} offen, solange Sie verlängern.",
  "billing.plans": "Tarife",
  "billing.monthly": "Monatlich",
  "billing.yearly": "Jährlich",
  "billing.month": "Monat",
  "billing.year": "Jahr",
  "billing.current": "Aktuell",
  "billing.choose": "Tarif wählen",
  "billing.renew": "Verlängern",
  "billing.contactUs": "Kontaktieren Sie uns",
  "billing.paid": "Zahlung erhalten — Ihr Tarif ist aktiv!",
  "billing.cancelled": "Zahlungsfenster geschlossen — es wurde nichts abgebucht.",
  "billing.orders": "Zahlungshistorie",
  "billing.date": "Datum",
  "billing.plan": "Tarif",
  "billing.amount": "Betrag",
  "billing.status": "Status",

  "revenue.title": "Umsatz",
  "revenue.subtitle": "Bezahlte Bestellungen über alle Mandanten.",
  "revenue.total": "Gesamteinnahmen",
  "revenue.paidOrders": "Bezahlte Bestellungen",
  "revenue.tenant": "Mandant",
  "revenue.empty": "Noch keine Zahlungen.",

  "dashboard.aiTitle": "Ihre KI-Coaches sind bereit",
  "dashboard.aiBody": "Erhalten Sie sofortiges, bewertetes Feedback zu Ihren Prüfungstexten und führen Sie fortlaufende Sprachgespräche mit dem KI-Sprechpartner — wie eine Expertin auf Abruf.",
  "dashboard.aiCta": "Zum Üben",
  "dashboard.examSkills": "Prüfungskompetenzen",
  "dashboard.examHint": "Die Beherrschung spiegelt Ihre besten Ergebnisse pro Prüfungsteil.",
  "dashboard.focusAreas": "Schwerpunkte",
  "dashboard.focusCommon": "Häufige B1-Schwerpunkte",
  "dashboard.focus.cases": "Die Kasuswahl wird in den Sprachbausteinen intensiv geprüft.",
  "dashboard.focus.clauses": "Wortstellungsregeln — das Verb steht am Ende.",
  "dashboard.focus.modals": "Sie kommen in fast jedem Teil-1-Text vor.",

  "monuments.title": "Wahrzeichen-Galerie",
  "monuments.subtitle": "Europäische Wahrzeichen — je in beiden Farbwelten.",

  "player.check": "Prüfen",
  "player.buildSentence": "Tippe die Wörter in der richtigen Reihenfolge an:",
  "player.continue": "Weiter",
  "player.mnemonic": "Merkhilfe",
  "player.tableMissing": "Diese Tabelle ist nicht verfügbar.",
  "player.yourText": "Ihr Text",
  "player.wordCount": "{count} Wörter",
  "player.compare": "Mit Musterlösung vergleichen",
  "player.modelAnswer": "Musterlösung",
  "player.saidIt": "Gesagt — Musterlösung zeigen",
  "player.correct": "Richtig!",
  "player.incorrect": "Nicht ganz.",
  "player.answerWas": "Antwort:",
  "player.loading": "Aufnahme wird geladen…",
  "player.listen": "Anhören",
  "player.pause": "Pause",
  "player.play": "Abspielen",
  "player.restart": "Neu starten",
  "player.speed": "Tempo",
  "player.normal": "Normal",
  "player.transcript": "Transkript",
  "player.audioUnavailable": "Audio ist in diesem Browser nicht verfügbar — lesen Sie das Transkript unten.",
  "player.clear": "Löschen",
  "player.finish.title": "Lektion abgeschlossen!",
  "player.finish.score": "Ergebnis",
  "player.finish.backToCourse": "Zurück zum Kurs",
  "player.exit": "Lektion verlassen",

  "common.cancel": "Abbrechen",
  "common.showPassword": "Passwort anzeigen",
  "common.hidePassword": "Passwort verbergen",
  "common.close": "Schließen",
  "common.save": "Speichern",
  "common.saving": "Wird gespeichert…",

  "nav.ai": "KI-Einstellungen",
  "ai.title": "KI-Einstellungen",
  "ai.subtitle": "Legen Sie fest, welcher KI-Dienst Schreib-Feedback, Sprechübungen und Antwort-Erklärungen übernimmt. Die Änderung gilt sofort für alle Schulen.",
  "ai.provider": "KI-Anbieter",
  "ai.recommended": "empfohlen",
  "ai.noKey": "noch kein Schlüssel",
  "ai.keyPresent": "Schlüssel hinterlegt",
  "ai.keyMissing": "Kein Schlüssel hinterlegt",
  "ai.strictSchema": "Zuverlässiges Feedback-Format",
  "ai.looseSchema": "Feedback-Format nicht garantiert",
  "ai.noKeyHelp": "Für diesen Anbieter ist auf dem Server noch kein API-Schlüssel hinterlegt. Die KI-Funktionen bleiben ausgeschaltet, bis einer eingetragen wird.",
  "ai.looseSchemaHelp": "Dieser Anbieter kann das von uns geforderte Feedback-Format nicht garantieren. Wir prüfen jede Antwort und versuchen es einmal erneut, dennoch sind Ausfälle wahrscheinlicher als bei den anderen Anbietern.",
  "ai.saved": "KI-Anbieter aktualisiert.",
  "ai.saveFailed": "KI-Anbieter konnte nicht aktualisiert werden.",
  "common.loading": "Lädt…",
  "mock.noContent": "Fuer dieses Niveau gibt es noch keine Pruefungssimulation. Die Aufgaben werden noch ergaenzt.",
  "common.error.generic": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  "doubt.title": "Frage stellen",
  "doubt.intro": "Kommen Sie nicht weiter? Fragen Sie in jeder Sprache — Hindi, Punjabi, Englisch — und wir antworten in dieser Sprache.",
  "doubt.placeholder": "z. B. Was ist der Unterschied zwischen 'der' und 'die'?",
  "doubt.ask": "Fragen",
  "doubt.off": "Der KI-Tutor ist derzeit nicht verfügbar.",
  "translate.tapHint": "Für die englische Übersetzung tippen",
  "translate.error": "Übersetzung fehlgeschlagen — zum Wiederholen tippen.",
  "common.required": "Pflichtfeld.",
};
